export const getPortalAminoAcids = (API, request, callback) => {
    API.get(`aminoacids`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}
